export default __webpack_public_path__ + "static/media/deedy-resume.e60da980.jpg";